let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h2cME")).then(() => parcelRequire('hH986'));